
/**
 * Hành động đối với công việc
 */
export const TaskAction = {
  /**
   * Lưu (Gửi)
   */
  Send: 'Send',

  /**
   * Lưu nháp
   */
  SaveDraft: 'SaveDraft',

  /**
   * Xóa
   */
  Delete: 'Delete',
};

/**
 * Trạng thái của công việc
 */
 export const TaskStatus = {
  /**
   * Vừa tạo
   */
  None: 0,

  /**
   * Lưu nháp
   */
  Draft: 1,

  /**
   * Đang thực hiện
   */
  InProcess: 2,

  /**
   * Hoàn thành
   */
  Completed: 3,
};